import GlobalStyle from '../src/styles/globalStyles';
import Link from 'next/link';
import NewHeader from '../src/components/HomePage/NewHeader';
import NewFooter from '../src/components/HomePage/NewFooter';
import { MainContainer } from '../src/components/Product/PdpHeader/styled';
import { categoryNavBarDataFetcher } from '../src/datafetchers/CategoryPage';
import { ErrorBoxContainer } from '../src/styles/404styles';
import { redirectToMyloUrl } from '../src/Utils/redirections';
import { useEffect } from 'react';
import { getFilteredCategoryContent } from '../src/Utils/helper';
import { NextSeo } from 'next-seo';
import { serverErrorMetaData } from '../src/Constants/MetaData';
import { fireEvent } from '../src/Utils/fireEvent';

export async function getStaticProps() {
  const categoryNavBarApiData = await categoryNavBarDataFetcher();
  return {
    props: {
      categoryData: getFilteredCategoryContent(categoryNavBarApiData?.data),
    },
  };
}

export default function Custom404(props) {
  const { categoryData } = props;

  useEffect(() => {
    fireEvent({
      category: 'viewed_500_page',
      screen: window.location.href,
    });
  }, []);

  return (
    <>
      <GlobalStyle />
      <NextSeo
        noindex={true}
        nofollow={true}
        title={serverErrorMetaData.metaTitle}
        description={serverErrorMetaData.metaDescription}
      />
      <NewHeader categoryNavBarData={categoryData} />
      <MainContainer>
        <ErrorBoxContainer>
          <h1>Error 500</h1>
          Oops, error encountered.
          <div>
            <Link href="/parenting">Go Back To Home</Link>
            <a onClick={() => redirectToMyloUrl('')}>Go Back To Store</a>
          </div>
        </ErrorBoxContainer>
      </MainContainer>
      <NewFooter />
    </>
  );
}
